<template>
  <div
    id="logout-btn"
    class="logout-container w-100 d-flex align-items-center"
    :class="{ 'logout-container-mobile': isMobile }"
    @click="
      logout(
        $store.getters.StateUser.user.user_type.includes('institute_admin') ||
          $store.getters.StateUser.user.user_type.includes('operator')
      )
    "
  >
    <v-icon color="error">mdi-logout</v-icon>
    <span class="error--text font-weight-medium mx-2">{{
      $t("header.logout")
    }}</span>
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js"

export default {
  name: "Logout",
  mixins: [GlobalMixin],
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.logout-container {
  cursor: pointer;
  padding: 1rem 0px;
  border-radius: 4px;

  &:hover {
    background-color: #ffebee;
  }

  &:active {
    background-color: #ffcdd2;
  }

  &.logout-container-mobile {
    padding: 0.3rem 0px;
    margin-top: 0.5rem;
  }
}
</style>
